import { AuthenticatedLayout } from "../../../../layouts";
import { FC } from "react";
import { RoleAssignmentList } from "../../../../components/RoleManagement/RolesAssignment/List";

export interface IRolesAssignmentListPage { }

export const RolesAssignmentListPage: FC<IRolesAssignmentListPage> = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Role Assignment List"
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[]}
      mainContents={<RoleAssignmentList />}
    />
  );
};
